import css from './td.module.css';
import type { ReactNode } from 'react';
export default function Td({
  children
}: {
  children: ReactNode;
}) {
  return <td className={css.td} data-sentry-component="Td" data-sentry-source-file="td.tsx">{children}</td>;
}